import { createIcon } from '@chakra-ui/react';

export const OrderArrow = createIcon({
  displayName: 'OrderArrow',
  viewBox: '0 0 10 13',
  path: [
    <path
      key="1"
      d="M6.01855 3.70746C6.01855 6.46199 6.02155 9.0421 6.01664 11.6219C6.01528 12.3733 5.61676 12.8323 4.99662 12.8291C4.37893 12.8259 3.99052 12.3665 3.98915 11.6088C3.98478 9.22497 3.98751 6.84145 3.98751 4.45792L3.98751 3.72029C3.39357 4.35438 2.8897 4.89339 2.38474 5.43181C2.15737 5.6739 1.94037 5.92911 1.69826 6.15311C1.26154 6.55707 0.660227 6.5282 0.282461 6.10615C-0.0802924 5.70131 -0.103493 5.07335 0.270178 4.63322C0.667323 4.16567 1.09886 3.73167 1.51702 3.28483C2.38883 2.35207 3.25873 1.41756 4.13518 0.489758C4.75396 -0.165623 5.25647 -0.163874 5.87962 0.4988C7.1019 1.79761 8.31954 3.10108 9.5369 4.40542C10.085 4.99256 10.1494 5.64123 9.71487 6.11577C9.27651 6.5944 8.65991 6.53724 8.11537 5.95769C7.44827 5.24777 6.78636 4.5323 6.01855 3.70746Z"
      fill="currentColor"
    />
  ]
});
